<template>
    <div class="wb-el-info-anchor"
         :style="{'top': top, 'left': left}">
        <div class="wb-el-info-container"
             :class="{'wb-el-info-transparent': !isTransparent}">
            <div class="wb-el-info">
                <div class="wb-el-info-buttons">
<!--                Список элементов с оверлеем в константе overlayElements-->
                    <NavbarCircleButton
                        v-if="isAccessoriesAvailable('Панель с крючками боковая')"
                        @click="()=>{addShelfAccessories('left', 'Панель с крючками боковая')}"
                    >
                      <template #svg>
                          <SVGHooksLeft class="wd-context-button-svg"/>
<!--                        <img src="hooks_left.png" width="24" height="24"/>-->
                      </template>
                    </NavbarCircleButton>
                    <NavbarCircleButton
                        v-if="isAccessoriesAvailable('Панель с крючками боковая')"
                        @click="()=>{addShelfAccessories('right', 'Панель с крючками боковая')}"
                    >
                      <template #svg>
<!--                        <img src="hooks_right.png" width="24" height="24"/>-->
                          <SVGHooksRight class="wd-context-button-svg"/>
                      </template>
                    </NavbarCircleButton>
                    <NavbarCircleButton
                        v-if="isAccessoriesAvailable('Полка боковая')" @click="()=>{addShelfAccessories('left', 'Полка боковая')}"
                    >
                        <template #svg>
                            <SVGSideShelfLeft class="wd-context-button-svg"/>
<!--                            <SVGShelfForShelfLeft/>-->
                        </template>
                    </NavbarCircleButton>
                    <NavbarCircleButton
                        v-if="isAccessoriesAvailable('Полка боковая')"
                        @click="()=>{addShelfAccessories('right', 'Полка боковая')}"
                    >
                      <template #svg>
                          <SVGSideShelfRight class="wd-context-button-svg"/>
<!--                        <SVGShelfForShelfRight/>-->
                      </template>
                    </NavbarCircleButton>


                  <NavbarCircleButton
                      v-if="isAccessoriesAvailable('Вешало торцевое')"
                      @click="() => {addShelfAccessories('center', 'Вешало торцевое')}">
                    <template #svg>
                      <SVGHanger class="wd-context-button-svg"/>
                    </template>
                  </NavbarCircleButton>

                    <NavbarCircleButton
                        v-if="isSeparatorAvailable"
                        @click="addSeparator"
                    >
                      <template #svg>
                        <SVGSeparatorAdd class="wd-context-button-svg"/>
                      </template>
                    </NavbarCircleButton>

                    <NavbarCircleButton
                        v-if="isSeparatorAvailable"
                        @click="removeSeparator"
                    >
                      <template #svg>
                        <SVGSeparatorRemove class="wd-context-button-svg"/>
                      </template>
                    </NavbarCircleButton>


                  <!--                    TODO раскомментить новые кнопки когда будет функционал-->
<!--                  <NavbarCircleButton @click="() => {}">-->
<!--                    <template #svg>-->
<!--                      <SVGBracketCover class="wd-context-button-svg"/>-->
<!--                    </template>-->
<!--                  </NavbarCircleButton>-->
<!--                    <NavbarCircleButton @click="() => {}">-->
<!--                        <template #svg>-->
<!--                            <SVGCloser class="wd-context-button-svg"/>-->
<!--                        </template>-->
<!--                    </NavbarCircleButton>-->
<!--                    <NavbarCircleButton @click="() => {}">-->
<!--                        <template #svg>-->
<!--                            <SVGHangToolBox class="wd-context-button-svg"/>-->
<!--                        </template>-->
<!--                    </NavbarCircleButton>-->
                  <NavbarCircleButton @click="deleteItem">
                    <template #svg>
                      <SVGDelete/>
                    </template>
                  </NavbarCircleButton>

                </div>
            </div>
<!--            <div class="wb-el-info-tooltip">-->
<!--                <SVGLamp/>-->
<!--                <div class="wb-el-info-tooltip-text">-->
<!--                    {{tooltipText}}-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import NavbarCircleButtonColor from '@/UI/Components/ComponentsNavbar/NavbarCircleButtonColor.vue';
import NavbarCircleButton from '@/UI/Components/ComponentsNavbar/NavbarCircleButton.vue';
import SVGDelete from '@/UI/Components/SVG/SVGDelete.vue';
import SVGColorItem from '@/UI/Components/SVG/SVGColorItem.vue';
import SVGLamp from '@/UI/Components/SVG/SVGLamp.vue';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useUIOnlyStore } from '@/Store/storeUI';
import SVGBar from '@/UI/Components/SVG/SVGBar.vue';
import { deleteEl } from '@/lib/deleteEl';
import { addShelfAccessories, getShelfAccessories, addSeparator, removeSeparator } from '@/lib/addShelfAccessories';
import SVGShelfForShelfLeft from '@/UI/Components/SVG/SVGShelfForShelfLeft.vue';
import SVGShelfForShelfRight from '@/UI/Components/SVG/SVGShelfForShelfRight.vue';
import SVGHooksLeft from '@/UI/Components/SVG/SVGHooksLeft.vue';
import SVGHooksRight from '@/UI/Components/SVG/SVGHooksRight.vue';
import SVGSideShelfLeft from '@/UI/Components/SVG/SVGSideShelfLeft.vue';
import SVGSideShelfRight from '@/UI/Components/SVG/SVGSideShelfRight.vue';
import SVGBracketCover from '@/UI/Components/SVG/SVGBracketCover.vue';
import SVGCloser from '@/UI/Components/SVG/SVGCloser.vue';
import SVGHangToolBox from '@/UI/Components/SVG/SVGHangToolBox.vue';
import SVGHanger from '@/UI/Components/SVG/SVGHanger.vue';
import SVGSeparatorAdd from '@/UI/Components/SVG/SVGSeparatorAdd.vue';
import SVGSeparatorRemove from '@/UI/Components/SVG/SVGSeparatorRemove.vue';

export default {
    name: 'OverlayElementInfo',
    components: {
        SVGHangToolBox,
        SVGCloser,
        SVGBracketCover,
        SVGSideShelfRight,
        SVGSideShelfLeft,
        SVGHooksRight,
        SVGHooksLeft,
      SVGShelfForShelfRight,
      SVGShelfForShelfLeft,
      SVGLamp,
        SVGBar,
        SVGDelete,
        NavbarCircleButton,
        SVGHanger,
        SVGSeparatorAdd,
        SVGSeparatorRemove,
    },
    setup() {
        const configurationStore = useConfigurationStore();
        const storeUI = useUIOnlyStore();
        // const storeData = useStoreData();
        return {
            configurationStore,
            storeUI,
            // storeData,
        };
    },
    props: [
        'top',
        'left',
        'openElementColorOverlay',
        'data',
    ],
    data() {
        return {
            tooltipText: 'Чтобы скопировать объект, зажмите Ctrl.',
        };
    },
    methods: {
      addShelfAccessories,
      addSeparator,
      removeSeparator,
      deleteItem() {
        deleteEl();
      },
    },
    computed: {
        isAccessoriesAvailable() {
          return (name) => {
            const selectedShelf = this.storeUI.selectedSceneObject;
            if (!selectedShelf || !selectedShelf.uuid) {
              return false;
            }
            // Ограничение: "Вешало торцевое" доступно только для "Полка сетчатая и Полка-корзина"
            if (name === 'Вешало торцевое') {
              const label = selectedShelf.label || '';
              const isAllowedShelf = label.includes('Полка сетчатая');
              if (!isAllowedShelf || selectedShelf.hasRod) {
                return false;
              }
            }
            const accessories = getShelfAccessories(name, selectedShelf);
            return accessories && accessories[0];
          };
        },
        isSeparatorAvailable() {
          const selectedShelf = this.storeUI.selectedSceneObject;
          return selectedShelf && selectedShelf.label?.includes('Полка-корзина');
        },
        isTransparent() {
            return this.storeUI.getElementInfoActive;
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";

.wd-context-button-svg {
    max-height: 28px;
    max-width: 28px;
}

.wb-el-info-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 100;
}

.wb-el-info {
    padding: 16px;
    height: 80px;
    width: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 16px;
    //background-color: $gray1;
    justify-content: space-between;
    transition: opacity 0.2s;
}
.wb-el-info-transparent {
    pointer-events: none;
    opacity: 0.4;
}

.wb-el-info-buttons {
    display: flex;
    flex-direction: row;
    gap: 16px;
}

.wb-el-info-text-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
}

.wb-el-info-label {
    @include font-t2b;
    @include wb-c-flex-center-start;
    height: 100%;
    color: $darkBlue;
    width: max-content;
}

.wb-el-info-text {
    @include font-t2;
    @include wb-c-flex-center-start;
    height: 100%;
    color: $gray3;
    width: max-content;
}

.wb-el-info-tooltip {
    background-color: $lightGreen;
    color: $green1;
    @include font-t1;
    padding: 16px;
    box-sizing: border-box;
    height: max-content;
    display: grid;
    grid-template-columns: max-content auto;
    grid-column-gap: 16px;
}

.wb-el-info-tooltip-text {
    color: $darkBlue;
    @include wb-c-flex-center-start;
    text-align: left;
    width: max-content;
}
</style>
